import { HTTP_URL } from "../config/backend";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Crewmate from "../components/Crewmate";
import { CheckCircle2, Zap, Crown, Loader2 } from "lucide-react";

const API = HTTP_URL;

const PLANS = [
  {
    id: "starter", label: "Попробовать", price: "99 ₽", rooms: 3,
    color: "#00f5ff", emoji: "🎮", popular: false,
    perks: ["3 игровые сессии", "Все PRO игры", "До 10 игроков"],
  },
  {
    id: "party", label: "Вечеринка", price: "299 ₽", rooms: 15,
    color: "#ff3cac", emoji: "🎉", popular: true,
    perks: ["15 игровых сессий", "Все PRO игры", "До 10 игроков"],
  },
  {
    id: "team", label: "Акция «6-7»", price: "670 ₽", rooms: 67,
    color: "#9b5de5", emoji: "🏆", popular: false,
    perks: ["67 игровых сессий", "Все PRO игры", "До 10 игроков"],
  },
];

function ProGamesList({ games, loading }) {
  if (loading) return (
    <div style={{ padding: "1.25rem 0", color: "#555", fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", textAlign: "center" }}>
      Загрузка...
    </div>
  );
  if (!games.length) return null;
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px,1fr))", gap: "0.6rem" }}>
      {games.map(g => (
        <div key={g.id} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <CheckCircle2 style={{ width: "1rem", height: "1rem", color: "#3dffa0", flexShrink: 0 }} />
          <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", color: "#ddd" }}>
            {g.emoji || "🎮"} {g.name}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function ProPage() {
  const navigate = useNavigate();
  const [codeInput, setCodeInput] = useState("");
  const [checking,  setChecking]  = useState(false);
  const [codeError, setCodeError] = useState("");
  const [codeOk,    setCodeOk]    = useState(null);
  const [proGames,  setProGames]  = useState([]);
  const [gamesLoading, setGamesLoading] = useState(true);
  const [agreed, setAgreed]   = useState(false);
  const [buying,  setBuying]  = useState(null);
  const [buyErr,  setBuyErr]  = useState("");
  const [email,   setEmail]   = useState("");

  useEffect(() => {
    fetch(`${API}/api/games`)
      .then(r => r.json())
      .then(data => setProGames((data.games || data || []).filter(g => g.tier === "pro" && g.disabled !== true)))
      .catch(() => setProGames([]))
      .finally(() => setGamesLoading(false));
  }, []);

  const activate = async () => {
    const code = codeInput.trim().toUpperCase();
    if (!code) return;
    setChecking(true); setCodeError(""); setCodeOk(null);
    try {
      const r = await axios.post(`${API}/api/promo/verify`, { code, game_type: "voting" });
      localStorage.setItem("neon_promo_code",  code);
      localStorage.setItem("neon_promo_rooms", String(r.data.rooms_left));
      setCodeOk(r.data.rooms_left);
    } catch (e) {
      setCodeError(e.response?.data?.detail || "Ошибка проверки кода");
    } finally {
      setChecking(false);
    }
  };

  const buyPlan = async (planId) => {
    if (!email.trim()) { setBuyErr("Укажи email — на него придёт промокод."); return; }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) { setBuyErr("Введи корректный email."); return; }
    if (!agreed) { setBuyErr("Необходимо принять условия оферты."); return; }
    setBuying(planId); setBuyErr("");
    if (window.ym) window.ym(108028446, 'reachGoal', 'checkout_start');
    try {
      const r = await axios.post(`${API}/api/payments/create`, { plan: planId, email: email.trim() });
      if (window.ym) window.ym(108028446, 'reachGoal', 'click_buy_pro');
      window.location.href = r.data.confirmation_url;
    } catch (e) {
      setBuyErr(e.response?.data?.detail || "Не удалось создать платёж. Попробуй ещё раз.");
      setBuying(null);
    }
  };

  return (
    <div className="page-root" style={{ minHeight: "100vh", color: "#fff" }}>
      <Navbar />
      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "3rem 1.5rem 5rem" }}>

        {/* HERO */}
        <div style={{ textAlign: "center", marginBottom: "3.5rem" }}>
          <div style={{ display: "flex", justifyContent: "center", gap: "0.75rem", marginBottom: "1.25rem" }}>
            <Crewmate color="#9b5de5" size={48} animate="wiggle" />
            <Crewmate color="#ff3cac" size={56} animate="bounce" />
            <Crewmate color="#ffe600" size={48} animate="wiggle" />
          </div>
          <div style={{
            display: "inline-flex", alignItems: "center", gap: "0.5rem",
            background: "#9b5de5", border: "2.5px solid #000",
            borderRadius: "9999px", boxShadow: "3px 3px 0 #000",
            padding: "0.35rem 1.25rem", marginBottom: "1.25rem",
            fontFamily: "'Fredoka One', sans-serif", fontSize: "0.9rem", color: "#fff",
          }}>
            <Crown style={{ width: "1rem", height: "1rem" }} /> PRO доступ
          </div>
          <h1 style={{
            fontFamily: "'Fredoka One', sans-serif",
            fontSize: "clamp(2.2rem,6vw,3.75rem)",
            color: "#fff", lineHeight: 1.1,
            textShadow: "4px 4px 0 #9b5de5, 8px 8px 0 #000",
            marginBottom: "1rem",
          }}>РАЗБЛОКИРУЙ ВСЕ ИГРЫ</h1>
          <p style={{
            fontFamily: "'Nunito', sans-serif", fontSize: "1.05rem",
            color: "#bbb", maxWidth: "520px", margin: "0 auto", lineHeight: 1.7,
          }}>
            Купи промокод — получи доступ ко всем PRO играм.<br/>
            Один код на всю компанию, без регистрации.
          </p>
        </div>

        {/* ЧТО ВХОДИТ В PRO */}
        <section style={{ marginBottom: "2.5rem" }}>
          <div className="card-cartoon">
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1.25rem", flexWrap: "wrap", gap: "0.5rem" }}>
              <h2 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.2rem", color: "#9b5de5", margin: 0 }}>
                ЧТО ВХОДИТ В PRO
              </h2>
              {!gamesLoading && proGames.length > 0 && (
                <span style={{
                  background: "#9b5de5", color: "#fff",
                  border: "2px solid #000", borderRadius: "0.5rem", boxShadow: "2px 2px 0 #000",
                  padding: "0.15rem 0.6rem",
                  fontFamily: "'Fredoka One', sans-serif", fontSize: "0.8rem",
                }}>
                  {proGames.length} игр
                </span>
              )}
            </div>
            <ProGamesList games={proGames} loading={gamesLoading} />
          </div>
        </section>

        {/* ТАРИФЫ */}
        <section style={{ marginBottom: "3rem" }}>
          <h2 style={{
            fontFamily: "'Fredoka One', sans-serif", fontSize: "1.75rem",
            color: "#ffe600", textAlign: "center", marginBottom: "0.5rem",
            textShadow: "3px 3px 0 #ff8c00, 5px 5px 0 #000",
          }}>ВЫБЕРИ ТАРИФ</h2>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", color: "#555", textAlign: "center", marginBottom: "1.25rem" }}>
            Оплата через ЮКассу · Карты, СБП, ЮMoney
          </p>

          {/* Email */}
          <div style={{ maxWidth: "340px", margin: "0 auto 1.75rem", textAlign: "center" }}>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.82rem", color: "#aaa", marginBottom: "0.4rem" }}>
              📧 Email для получения промокода <span style={{ color: "#ff3355" }}>*</span>
            </p>
            <input
              type="email" value={email}
              onChange={e => { setEmail(e.target.value); setBuyErr(""); }}
              placeholder="your@email.com"
              style={{
                width: "100%", boxSizing: "border-box",
                background: "#0d0520",
                border: `2.5px solid ${buyErr && !email.trim() ? "#ff3355" : "#ffffff22"}`,
                borderRadius: "0.75rem", color: "#fff", padding: "0.7rem 1rem",
                fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem",
                outline: "none", textAlign: "center",
              }}
            />
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.75rem", color: "#444", marginTop: "0.3rem" }}>
              Промокод придёт сразу после оплаты
            </p>
          </div>

          {/* Чекбокс согласия с офертой */}
          <div style={{ maxWidth: "560px", margin: "0 auto 1.75rem", display: "flex", alignItems: "flex-start", gap: "0.6rem", cursor: "pointer" }}
            onClick={() => setAgreed(a => !a)}>
            <div style={{
              width: "1.25rem", height: "1.25rem", flexShrink: 0, marginTop: "0.1rem",
              background: agreed ? "#3dffa0" : "#0d0520",
              border: `2.5px solid ${agreed ? "#000" : "#ffffff33"}`,
              borderRadius: "0.35rem", boxShadow: agreed ? "2px 2px 0 #000" : "none",
              display: "flex", alignItems: "center", justifyContent: "center",
              transition: "all 0.15s",
            }}>
              {agreed && <span style={{ color: "#000", fontSize: "0.85rem", fontWeight: "bold" }}>✓</span>}
            </div>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", color: "#888", margin: 0, lineHeight: 1.6 }}>
              Я принимаю условия{" "}
              <a href="/offer" target="_blank" style={{ color: "#ff3cac", textDecoration: "underline" }}
                onClick={e => e.stopPropagation()}>публичной оферты</a>
              {" "}и{" "}
              <a href="/terms" target="_blank" style={{ color: "#9b5de5", textDecoration: "underline" }}
                onClick={e => e.stopPropagation()}>пользовательского соглашения</a>
            </p>
          </div>

          {/* Карточки тарифов — мультяшный стиль */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px,1fr))", gap: "1rem" }}>
            {PLANS.map(p => (
              <div key={p.id} className="card-cartoon" style={{
                background: p.popular ? `${p.color}18` : "#16103a",
                display: "flex", flexDirection: "column",
                position: "relative",
                ...(p.popular ? { boxShadow: `6px 6px 0 #000` } : {}),
              }}>
                {p.popular && (
                  <div style={{
                    position: "absolute", top: "-1rem", left: "50%", transform: "translateX(-50%)",
                    background: p.color, border: "2.5px solid #000",
                    borderRadius: "9999px", boxShadow: "2px 2px 0 #000",
                    padding: "0.2rem 0.9rem",
                    fontFamily: "'Fredoka One', sans-serif", fontSize: "0.75rem", color: "#000", whiteSpace: "nowrap",
                  }}>⭐ Популярный</div>
                )}

                <div style={{ textAlign: "center", marginBottom: "1rem" }}>
                  <div style={{ fontSize: "2.5rem", marginBottom: "0.25rem" }}>{p.emoji}</div>
                  <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.15rem", color: "#fff", marginBottom: "0.1rem" }}>{p.label}</p>
                  <p style={{
                    fontFamily: "'Fredoka One', sans-serif", fontSize: "2.5rem",
                    color: p.color, lineHeight: 1,
                    textShadow: `2px 2px 0 #000`,
                  }}>{p.price}</p>
                  <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", color: "#888" }}>{p.rooms} игровых сессий</p>
                </div>

                <div style={{ flex: 1, marginBottom: "1.25rem" }}>
                  {p.perks.map((perk, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: "0.4rem", marginBottom: "0.35rem" }}>
                      <CheckCircle2 style={{ width: "0.9rem", height: "0.9rem", color: p.color, flexShrink: 0 }} />
                      <span style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.85rem", color: "#ccc" }}>{perk}</span>
                    </div>
                  ))}
                </div>

                <button
                  onClick={() => buyPlan(p.id)}
                  disabled={!!buying}
                  className="btn-cartoon"
                  style={{
                    width: "100%",
                    background: buying === p.id ? "#333" : p.color,
                    color: p.color === "#9b5de5" ? "#fff" : "#000",
                    opacity: buying && buying !== p.id ? 0.5 : 1,
                    display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem",
                    fontSize: "1rem",
                  }}
                >
                  {buying === p.id
                    ? <><Loader2 style={{ width: "1rem", height: "1rem", animation: "spin 1s linear infinite" }} /> Загрузка...</>
                    : `Купить за ${p.price}`
                  }
                </button>
              </div>
            ))}
          </div>

          {buyErr && (
            <p style={{ fontFamily: "'Nunito', sans-serif", color: "#ff3355", fontSize: "0.9rem", textAlign: "center", marginTop: "1rem" }}>
              ❌ {buyErr}
            </p>
          )}
        </section>

        {/* АКТИВАЦИЯ КОДА */}
        <section className="card-cartoon" style={{ textAlign: "center" }}>
          <div style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            background: "#ffe600", border: "2.5px solid #000",
            borderRadius: "1rem", boxShadow: "3px 3px 0 #000",
            width: "3rem", height: "3rem", marginBottom: "0.75rem",
          }}>
            <Zap style={{ width: "1.5rem", height: "1.5rem", color: "#000" }} />
          </div>
          <h2 style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.3rem", color: "#ffe600", marginBottom: "0.5rem" }}>
            УЖЕ ЕСТЬ КОД?
          </h2>
          <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: "0.9rem", color: "#888", marginBottom: "1.25rem" }}>
            Введи промокод — PRO игры разблокируются в браузере
          </p>

          {codeOk !== null ? (
            <div style={{ background: "#001a00", border: "2.5px solid #000", boxShadow: "4px 4px 0 #3dffa0", borderRadius: "1rem", padding: "1.25rem" }}>
              <p style={{ fontFamily: "'Fredoka One', sans-serif", fontSize: "1.3rem", color: "#3dffa0" }}>✅ Код активирован!</p>
              <p style={{ fontFamily: "'Nunito', sans-serif", color: "#aaa", marginTop: "0.4rem" }}>
                Доступно сессий: <strong style={{ color: "#fff" }}>{codeOk === 999999 ? "∞" : codeOk}</strong>
              </p>
              <button onClick={() => navigate("/games")} className="btn-cartoon btn-success" style={{ marginTop: "1rem", padding: "0.6rem 1.75rem", fontSize: "1.05rem" }}>
                🎮 Играть →
              </button>
            </div>
          ) : (
            <>
              <div style={{ display: "flex", flexDirection: "column", gap: "0.65rem", maxWidth: "400px", margin: "0 auto" }}>
                <input
                  type="text" value={codeInput}
                  onChange={e => setCodeInput(e.target.value.toUpperCase())}
                  onKeyDown={e => e.key === "Enter" && activate()}
                  placeholder="PRO-XXXX-XXXX"
                  maxLength={20}
                  style={{
                    width: "100%", boxSizing: "border-box",
                    background: "#0d0520", border: "2.5px solid #ffe60055",
                    borderRadius: "0.75rem", color: "#fff", padding: "0.7rem 1rem",
                    fontFamily: "'Nunito', sans-serif", fontWeight: 700,
                    fontSize: "1.1rem", letterSpacing: "0.08em",
                    outline: "none", textAlign: "center",
                  }}
                />
                <button
                  onClick={activate} disabled={!codeInput.trim() || checking}
                  className="btn-cartoon btn-accent"
                  style={{ width: "100%", fontSize: "1.1rem", padding: "0.75rem" }}
                >{checking ? "Проверка..." : "Активировать"}</button>
              </div>
              {codeError && <p style={{ fontFamily: "'Nunito', sans-serif", color: "#ff3355", fontSize: "0.9rem", marginTop: "0.75rem" }}>❌ {codeError}</p>}
            </>
          )}
        </section>

      </div>
    </div>
  );
}